import $ from 'jquery';
const TITLE = '.js-accord-title';
const BODY = '.js-accord-body';
const ARROW = '.ProductAccordion-arrow';
export const init = async function() {
    $(document).on('click', TITLE, (item)=>{
        $(item.target).next(BODY).slideToggle();
        $(item.target).find(ARROW).toggleClass('open');
    });
    //KEYBOARD USERS
    $(document).on('keyup', TITLE, (item)=>{
        if (item.keyCode === 13) {
            $(item.target).next(BODY).slideToggle();
            $(item.target).find(ARROW).toggleClass('open');
        }
    });
};
